module.exports = __webpack_public_path__ + "img/kfwx.6670180e.png";